import { FiTwitter,
  FiFacebook,
  FiLinkedin,
  FiInstagram
} from 'react-icons/fi'




const Footer = () => {
  return(
    <footer className="container-fluid bg-primary division2">
      <div className="container text-white text-center d-flex flex-column align-items-center">
        <h1 className="division2">
          subscribe now
        </h1>
        <div className="row col-12 col-md-10 col-lg-7 m-3">
          <input
          type="text"
          className="form-control
          form-control-lg"
          placeholder="email"
          />
        </div>
        <button className="btn btn-secondary">
          subscribe
        </button>
        <div className="my-3">
          <FiLinkedin
          size={20}
          className="mr-1"
          />
          <FiFacebook
          size={20}
          className="mr-1"
          />
          <FiTwitter
          size={20}
          className="mr-1"
          />
          <FiInstagram
          size={20}
          />
        </div>
        <small
        className="mb-4"
        style={{fontSize: '12px'}}>
          copyright 2021 all rights reserved
        </small>
      </div>
    </footer>
  )
}
export default Footer;